export default "__VITE_ASSET__D96T41EQ__"